import React from 'react';
import { FaHotel } from 'react-icons/fa';

const HotelLoader = ({ city, checkIn, checkOut, guests, rooms }) => {
    return (
        <div className="flex items-center justify-center px-4" style={{ minHeight: '70vh' }}>
            <div className="bg-white rounded-2xl border border-ink-100 shadow-card px-8 py-10 sm:px-12 sm:py-12 text-center max-w-sm w-full">
                <div className="relative h-16 w-16 mx-auto mb-6">
                    <div className="absolute inset-0 rounded-full border-4 border-brand-100" />
                    <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-brand-600 animate-spin" />
                    <div className="absolute inset-0 flex items-center justify-center">
                        <FaHotel className="text-brand-600" size={18} />
                    </div>
                </div>

                <h5 className="text-lg font-bold text-ink-900 mb-1.5">Please wait...</h5>
                <p className="text-sm text-ink-500 mb-5">We are looking for all available hotels for you</p>

                {(city || checkIn || checkOut) && (
                    <div className="border-t border-ink-100 pt-4 space-y-1">
                        {city && <p className="text-sm font-semibold text-ink-700">{city}</p>}
                        {(checkIn || checkOut) && (
                            <p className="text-sm text-ink-500">
                                {checkIn} <span className="text-ink-300">&rarr;</span> {checkOut}
                            </p>
                        )}
                        {(guests || rooms) && (
                            <p className="text-xs text-ink-400">
                                Guests: {guests} &nbsp;|&nbsp; Rooms: {rooms}
                            </p>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default HotelLoader;
